const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:8080"
};

export default config;
